import { closeModal } from "../../../ui/containers/Modal";
import { floodFill } from "../../../ui/helpers";
import { ButtonComp } from "../../../ui/input/Button";
import { TextButton } from "../../../ui/input/TextButton";
import { ALIGN_TYPE, TextType } from "../../../ui/type/TextType";
import { ComponentF, createElement } from "../../../ui/ui";
import { Actor } from "../../actors/Actor";
import Colors from "../../Colors";
import { LetterSelectInput } from "./LetterSelectInput";

export const LetterSelect: ComponentF<{
  title: string;
  description: string;
  actor: Actor;
  max: number;
  min: number;
  onResult: (result: { letters: string[] }) => void;
  onCancel: () => void;
}> = (C, props) => {
  const [state, setState] = C.useState({ letters: [] });

  floodFill(C.display, C.bounds, Colors.OFF_BLACK);

  return [
    createElement(
      TextType,
      { x: 1, y: 0, w: C.bounds.w - 2, h: 1 },
      { title: props.title, align: ALIGN_TYPE.center }
    ),
    createElement(
      TextType,
      { x: 1, y: 2, w: C.bounds.w - 2, h: 1 },
      { title: props.description, align: ALIGN_TYPE.center }
    ),
    createElement(
      LetterSelectInput,
      { x: 1, y: Math.floor(C.bounds.h / 2), w: C.bounds.w, h: 3 },
      {
        letters: state.letters,
        spellWand: props.actor.spellWand,
        onUpdateLetters: (letters: any) => setState({ letters }),
        max: props.max,
        upperCase: props.actor.breed.isCapital,
      }
    ),
    createElement(
      TextButton,
      { x: C.bounds.w - 13, y: C.bounds.h - 1, w: C.bounds.w - 1, h: 1 },
      {
        title: "Confirm",
        keyLabel: "Enter",
        keys: ["Enter"],
        disabled:
          !state.letters.length || state.letters.length < (props.min || 0),
        onClick: () => {
          if (
            state.letters.length &&
            state.letters.length >= (props.min || 0)
          ) {
            closeModal();
            props.onResult({ letters: state.letters });
          }
        },
      }
    ),
    createElement(
      TextButton,
      { x: 0, y: C.bounds.h - 1, w: 10, h: 1 },
      {
        title: "Cancel",
        keyLabel: "Esc",
        keys: ["Escape"],
        onClick: () => {
          closeModal();
          props.onCancel();
        },
      }
    ),
  ];
};
